import 'css-chunksrc/client/scenes/task/allocations/allocation/styles.scss';export default {
  "allocation": "_allocation_1h72e_1",
  "removeAllocation": "_removeAllocation_1h72e_12",
  "resource": "_resource_1h72e_16",
  "container": "_container_1h72e_24",
  "label": "_label_1h72e_33",
  "center": "_center_1h72e_39",
  "avatar": "_avatar_1h72e_43",
  "user": "_user_1h72e_48",
  "name": "_name_1h72e_54",
  "title": "_title_1h72e_60",
  "allocatedHours": "_allocatedHours_1h72e_65",
  "completionCheck": "_completionCheck_1h72e_82",
  "binIcon": "_binIcon_1h72e_90"
};